import { makeStyles } from '@material-ui/core/styles';

const LIGHT_BLUE_COLOR = "#0C85F4";
const LIGHT_WHITE_COLOR = "#EDF3FA";

export const useStyles = makeStyles((theme: any) => {
    return {
        container: {
            width: '100%',
            justifyContent: 'flex-start',
            flexDirection: "column",
        },
        labelContainer: {
            flexDirection: "row",
            display: 'flex',
            height: "75px",
            alignItems: "center",
            marginBottom: "50px",
        },
        tab: {
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: 600,
            padding: "15px",
            lineHeight: "17px",
            letterSpacing: "0em",
            textAlign: "left",
            marginRight: "20px",
            '&:hover': {
                backgroundColor: LIGHT_WHITE_COLOR,
                borderRadius: "50px",
                color: LIGHT_BLUE_COLOR,
                cursor: "pointer"
            },
        },
        label: {
            fontFamily: "Montserrat",
            fontSize: "14px",
            padding: "15px",
            fontWeight: 600,
            justifyContent: "center",
            alignItems: "center",
            textAlign: "center",
            '&:hover': {
                backgroundColor: LIGHT_WHITE_COLOR,
                borderRadius: 50,
                color: LIGHT_BLUE_COLOR,
                cursor: "pointer",
            },
            marginRight: "10px"
        },
        labelSelected: {
            fontFamily: "Montserrat",
            fontSize: "14px",
            fontWeight: 600,
            padding: "15px",
            lineHeight: "17px",
            letterSpacing: "0em",
            textAlign: "left",
            color: LIGHT_BLUE_COLOR,
            backgroundColor: LIGHT_WHITE_COLOR,
            justifyContent: "center",
            alignItems: "center",
            marginRight: "10px",
            borderRadius: 50,
            '&:hover': {
                color: LIGHT_BLUE_COLOR,
            },
        }
    };
});
